<button #openButton mat-button class="open-select-button" (click)="open()" aria-haspopup="dialog">
  <span class="button-content-wrapper">
    <span class="placeholder">{{ placeholder }}</span>
    <vue-number-indicator
      [number]="selectedAmount"
    ></vue-number-indicator>
    <img class="select-carrot" src="/assets/icons/icon-open-select.svg" alt=""/>
  </span>
</button>
